export default "__VITE_ASSET__djQPTjKT__"